import React from 'react';
import { graphql, StaticQuery } from 'gatsby';
import {
  Section,
  SectionHeader,
  WayPointHandler,
  BlogSlider,
} from 'components';
import TwoCompanies from './TwoCompanies';
import Awards from './Awards';
import './About.scss';
import { sliderData } from './logic';

const subheader =
  'Boldare is a brand that emerged from combining the power and best qualities of two companies: XSolve, a software development company and Chilid, a high-end web design agency.<br /><br />We draw our strength from the skills and experience of our 130 talented professionals and the foolproof processes that guide our collaborative product design and development practice.';

const About = () => (
  <StaticQuery
    query={graphql`
      query {
        about: file(relativePath: { eq: "about-us/about-1.png" }) {
          childImageSharp {
            fluid(maxWidth: 1670) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        boldareWireframe: file(
          relativePath: { eq: "about-us/boldare-wireframe-mock.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 1670) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        mobiles: file(relativePath: { eq: "about-us/mobiles.png" }) {
          childImageSharp {
            fluid(maxWidth: 1670) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `}
    render={data => (
      <WayPointHandler path="about">
        <>
          <Section additionalClass={'about'}>
            <SectionHeader lineColor={'black'} description={subheader}>
              About
            </SectionHeader>
          </Section>
          <BlogSlider
            theme={'dark'}
            data={sliderData.map(slide => ({
              ...slide,
              background: data[slide.background].childImageSharp.fluid,
            }))}
          />
          <Section color={'white'}>
            <SectionHeader
              description={
                'Boldare stands for quality. Our award-winning digital products are internationally recognized for beautiful interfaces, stellar user experience, our innovative approach and impeccable code quality.'
              }
              size={'medium'}
            >
              Awards &amp; rankings
            </SectionHeader>
            <TwoCompanies />
            <Awards />
          </Section>
        </>
      </WayPointHandler>
    )}
  />
);

export default About;
